export default {
  data: () => ({
    resultArray: [],
    resultTotalRows: 0,
    showTable: false,
    table: null,
    tableColumns: [],
    tableData: [],
    showSpreadsheet: false,
    showDimensionTable: false,
    spreadsheetData: [],
    spreadsheetFilter: [],
    querySchema: [],
    selectedTreeItems: [],
    totalmt1: 0,
    totalmt1compare: 0,
    totalmt1compareperct: 0,
    totalmt2: 0,
    totalmt2compare: 0,
    totalmt2compareperct: 0,
    totalmt3: 0,
    filterDimensionArray: [],
    displayFilterItem: "",
    displayFilterBy: "",
    searchCustNo: "%",
    searchCustName: "%",
    searchProdNo: "%",
    searchProdName: "%",
    filterItem: "",
    filterBy: "",
    filterOptions: [
      "Cust. Name",
      "Cust. No.",
      "Product Shortname",
      "Product No.",
    ],
    sortItem: "name",
    sortType: "Ascending",
    sortItemOptions: [
      { text: "Item", value: "name" },
      { text: "MT (1) ", value: "mt1" },
      { text: "+/- (1)", value: "compare1mt" },
      { text: "+/- % (1)", value: "compare1mtperct" },
      { text: "MT (2)", value: "mt2" },
      { text: "+/- (2)", value: "compare2mt" },
      { text: "+/- % (2)", value: "compare2mtperct" },
      { text: "MT (3)", value: "mt3" },
    ],
    sortTypeOptions: ["Ascending", "Descending"],
    showReportDimensions: false,
    selectedDimArray: [{ value: "area", name: "Area", width: 80 }],
    availableDimArray: [
      { value: "custcat", name: "Cust. Cat.", width: 150 },
      { value: "custgroup", name: "Cust. Group", width: 200 },
      { value: "nkagroup", name: "Modern Trade Group", width: 200 },
      { value: "category", name: "Prod. Cat.", width: 150 },
      { value: "brand", name: "Prod. Brand", width: 200 },
      { value: "uom", name: "Packaging", width: 80 },
    ],
    areaReportLoading: false,
    areaReportArray: [],
    categoryReportArray: [],
    brandReportArray: [],
    resultTotalRows: 0,
    resultArray: [],
    resultHeaders: [],
    showDatePickers: true,
    dateTo3: "",
    showDateTo3: false,
    dateFrom3: "",
    showDateFrom3: false,
    dateTo2: "",
    showDateTo2: false,
    dateFrom2: "",
    showDateFrom2: false,
    dateTo1: "2020-03-31",
    showDateTo1: false,
    dateFrom1: "2020-03-01",
    showDateFrom1: false,
  }),
};
